import React from "react";
import { Link } from "react-router-dom";
import { getAccessToken } from "../utils/fetchFunctions";
import "./hero.css";

const Hero = () => {
  const accessToken = getAccessToken();

  return (
    <section className="hero">
      <div className="hero__inner">
        <div className="hero__content">
          <h1 className="hero__title">EHDS Guide</h1>
          <p className="hero__subtitle">
            The Guide to Secure and Sustainable Health Data
          </p>
          <p className="hero__lead">
            Knowledge, methods and practical templates for the secure and
            efficient handling of health data within the EHDS framework.
          </p>
          <p className="hero__description">
            Do the complex requirements for data security, interoperability, 
            and data protection leave you feeling uncertain? 
            Would you like to increase efficiency, promote the use of public resources, 
            and at the same time fulfill your obligations as a data holder, provider, or user?
          </p>
          <p className="hero__descriptionBold">
            It’s simple—with the guide!
          </p>
          <p className="hero__description">
            The EHDS Guide supports you—whether you’re a business, public institution, 
            policymaker, or citizen—with knowledge, practical methods, 
            and templates to help you use your data effectively and sustainably.
          </p>
          <div className="hero__actions">
            {!accessToken && (
              <Link to="/register" className="hero__cta">
                ➢ Get started now!
              </Link>
            )}
            <button
              type="button"
              className="hero__cta hero__cta--secondary"
              onClick={() =>
                document
                  .getElementById("about")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Learn more
            </button>
          </div>
        </div>
        <div className="hero__visual" aria-hidden="true">
          <div className="hero__visual-card">
            <div className="hero__visual-chart">
              <span className="hero__dot hero__dot--primary" />
              <span className="hero__dot hero__dot--secondary" />
              <span className="hero__dot hero__dot--accent" />
            </div>
            <div className="hero__visual-bars">
              <span />
              <span />
              <span />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
